import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { SR_API_ACTION_ARCHIVE_RENTLINX_LISTING_LEAD } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';
import setNullEmptyValues from 'common/util/setNullEmptyValues';

import ButtonDeprecated, { BUTTON_THEME_GRAY_GREYCLIFF } from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrArchiveListingLeadModal from 'client/components/SrArchiveListingLeadModal';

const HitlistTaskListRowArchiveLead = ({ rentlinxListingLeadId, dispatch, getHitlistTasks }) => {
  const [showModal, setShowModal] = useState(false);

  const archiveLead = (values) => {
    dispatch(postWithState, {
      action: SR_API_ACTION_ARCHIVE_RENTLINX_LISTING_LEAD,
      payload: setNullEmptyValues({
        rentlinxListingLeadId: rentlinxListingLeadId,
        archiveReasons: values.archiveReasons,
        archiveReasonsDescription: values.archiveReasonsDescription,
        partnerArchiveReason: values.partnerArchiveReason,
      }),
      onSuccess: () => {
        getHitlistTasks();
      },
    });
  };

  return (
    <SrBox margin="20px 0" maxWidth="270px">
      <ButtonDeprecated
        onClick={() => setShowModal(true)}
        className="hitlist"
        theme={BUTTON_THEME_GRAY_GREYCLIFF}
      >
        Archive Lead
      </ButtonDeprecated>
      {showModal && (
        <SrArchiveListingLeadModal onClose={() => setShowModal(false)} onSubmit={archiveLead} />
      )}
    </SrBox>
  );
};

HitlistTaskListRowArchiveLead.displayName = 'HitlistTaskListRowArchiveLead';

HitlistTaskListRowArchiveLead.propTypes = {
  rentlinxListingLeadId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  getHitlistTasks: PropTypes.func.isRequired,
};

export default HitlistTaskListRowArchiveLead;
